module.exports = __webpack_public_path__ + "static/media/rec_point5.bc304b00.svg";